import { onMounted, ref } from "vue";

export function useDeviceDetector() {
  const deviceType = ref("");
  const operatingSystem = ref("");
  const cryptoWallets = ref([]);

  const detectDeviceType = () => {
    const userAgent = navigator.userAgent.toLowerCase();
    const isMobile = /mobile|android|iphone|ipad|ipod/.test(userAgent);
    const isTablet =
      /tablet|ipad|playbook|silk|kindle/.test(userAgent) &&
      !/mobile/.test(userAgent);

    if (isTablet) {
      return "tablet";
    }
    else if (isMobile) {
      return "mobile";
    }
    else {
      return "desktop";
    }
  };

  const detectOS = () => {
    const userAgent = navigator.userAgent.toLowerCase();
    console.log("userAgent", userAgent);

    if (userAgent.includes("android")) {
      return "Android / " + userAgent;
    }
    if (userAgent.includes("ios") || userAgent.includes("ipad") || userAgent.includes("iphone")) {
      return "iOS / " + userAgent;
    }
    if (userAgent.includes("windows")) {
      return "Windows / " + userAgent;
    }
    if (userAgent.includes("mac os")) {
      return "macOS / " + userAgent;
    }
    if (userAgent.includes("linux")) {
      return "Linux / " + userAgent;
    }

    return userAgent;
  };

  const detectCryptoWallets = async () => {
    const detectedWallets = [];

    // Проверяем наличие популярных кошельков
    const wallets = {
      MetaMask:
        typeof window.ethereum !== "undefined" && window.ethereum.isMetaMask,
      "Trust Wallet":
        typeof window.ethereum !== "undefined" && window.ethereum.isTrust,
      "Coinbase Wallet":
        typeof window.ethereum !== "undefined" &&
        window.ethereum.isCoinbaseWallet,
      Phantom: typeof window.phantom !== "undefined" && window.phantom.solana,
      Solflare: typeof window.solflare !== "undefined",
      "Brave Wallet":
        typeof window.ethereum !== "undefined" && window.ethereum.isBraveWallet,
      "OKX Wallet": typeof window.okxwallet !== "undefined"
    };

    // Проверяем Ethereum кошельки
    if (typeof window.ethereum !== "undefined") {
      detectedWallets.push("Ethereum Provider (Generic)");

      // Проверяем конкретные кошельки
      Object.keys(wallets).forEach((walletName) => {
        if (wallets[walletName]) {
          detectedWallets.push(walletName);
        }
      });

      // Дополнительная проверка через запрос аккаунтов
      try {
        const accounts = await window.ethereum.request({
          method: "eth_accounts"
        });
        if (accounts.length > 0) {
          detectedWallets.push("Ethereum Wallet Connected");
        }
      }
      catch (error) {
        console.log("Ethereum accounts request failed:", error);
      }
    }

    // Проверяем Solana кошельки
    if (typeof window.solana !== "undefined" && window.solana.isPhantom) {
      detectedWallets.push("Phantom (Solana)");
    }

    if (typeof window.solflare !== "undefined") {
      detectedWallets.push("Solflare");
    }

    return detectedWallets.length > 0
      ? detectedWallets
      : ["No crypto wallets detected"];
  };

  const detectAll = async () => {
    deviceType.value = detectDeviceType();
    operatingSystem.value = detectOS();
    cryptoWallets.value = await detectCryptoWallets();

    // console.group("Device & Wallet");
    // console.log("Device:", deviceType.value);
    // console.log("OS:", operatingSystem.value);
    // console.log("Crypto Wallets:", cryptoWallets.value);
    // console.groupEnd();

    return {
      deviceType: deviceType.value,
      operatingSystem: operatingSystem.value,
      cryptoWallets: cryptoWallets.value
    };
  };

  onMounted(async () => {
    await detectAll();
  });

  return {
    deviceType,
    operatingSystem,
    cryptoWallets,
    detectAll
  };
}
